import { setupVendorGlobals } from './vendor.js';
import { Budoevents } from './Budoevents.js';

setupVendorGlobals();

document.addEventListener('DOMContentLoaded', async () => {
    try {
        window.BUDOEVENTS = new Budoevents();
        await window.BUDOEVENTS.boot();
    } catch (error) {
        console.error('BUDO Events boot failed.', error);
    }
});
